<template>
    <icon-label
        v-bind="vBind"
        :size="size"
        :show-icon="showIcon"
        :show-label="showLabel" />
</template>

<script setup>
import IconLabel from '@/common/icon-label/icon-label.vue';
import { computed } from 'vue';

import { ITEM_TYPES } from '@/voc/constants/explore.js';

const { type, title } = defineProps({
    type: {
        type: String,
        default: 'topic',
        validator: (value) => ['topic', 'highlight', 'feedback', 'idea', 'ideapoll', 'portal', 'proxy'].includes(value),
    },
    title: {
        type: String,
        default: '',
    },
    showIcon: {
        type: Boolean,
        default: true,
    },
    showLabel: {
        type: Boolean,
        default: true,
    },
    size: {
        type: String,
        default: 'large',
    },
});

const vBind = computed(() => {
    const hasImg = ['topic', 'highlight'].includes(type);
    const hasIcon = ['feedback', 'idea', 'portal', 'ideapoll', 'proxy'].includes(type);

    return {
        ...(hasImg && { imgSrc: require(`@img/voc/${ITEM_TYPES[type].icon}`) }),
        ...(hasIcon && { icon: ITEM_TYPES[type].icon }),
        label: `${ITEM_TYPES[type].label}${title ? `: ${title}` : ''}`,
    };
});
</script>
